import { AppErrorPage } from "@/components/common/pages/error-screen";
import { appErrorPaths, buildAppErrorUrl } from "@/lib/app-error-routes";
import { useEffect } from "react";

export default function NotFound() {
  const from =
    typeof window === "undefined"
      ? undefined
      : `${window.location.pathname}${window.location.search}${window.location.hash}`;

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }

    if (window.location.pathname === appErrorPaths["404"]) {
      return;
    }

    window.location.replace(buildAppErrorUrl("404", from));
  }, [from]);

  return <AppErrorPage type="404" from={from} />;
}
